export default "__VITE_ASSET__48f840ae__"